'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _css = require('antd/lib/cascader/style/css');

var _cascader = require('antd/lib/cascader');

var _cascader2 = _interopRequireDefault(_cascader);

var _css2 = require('antd/lib/input/style/css');

var _input = require('antd/lib/input');

var _input2 = _interopRequireDefault(_input);

var _css3 = require('antd/lib/message/style/css');

var _message = require('antd/lib/message');

var _message2 = _interopRequireDefault(_message);

var _css4 = require('antd/lib/form/style/css');

var _form = require('antd/lib/form');

var _form2 = _interopRequireDefault(_form);

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; /**
                                                                                                                                                                                                                                                                   * 创建/编辑自提点按钮及表单
                                                                                                                                                                                                                                                                   */


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _axios = require('axios');

var _axios2 = _interopRequireDefault(_axios);

var _constants = require('../constants');

var _areas = require('../utils/areas');

var _areas2 = _interopRequireDefault(_areas);

var _modal_form = require('./modal_form');

var _modal_form2 = _interopRequireDefault(_modal_form);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FormItem = _form2.default.Item;

var PickupStationForm = _react2.default.createClass({
    displayName: 'PickupStationForm',
    onOk: function onOk(form) {
        return _axios2.default.post(_constants.API_PICKUPSTATIONS, form.getFieldsValue()).then(function (response) {
            _message2.default.info('操作成功', 1.5);
        }).catch(function (error) {
            _message2.default.error('\u64CD\u4F5C\u5931\u8D25\uFF1A' + error.data, 2);
        });
    },
    render: function render() {
        var _props = this.props,
            _props$pickupStation = _props.pickupStation,
            pickupStation = _props$pickupStation === undefined ? { address: {} } : _props$pickupStation,
            form = _props.form,
            style = _props.style,
            _props$title = _props.title,
            title = _props$title === undefined ? '创建自提点' : _props$title,
            _props$btnText = _props.btnText,
            btnText = _props$btnText === undefined ? title : _props$btnText;
        var getFieldDecorator = form.getFieldDecorator;

        var formItemLayout = {
            labelCol: { span: 6 },
            wrapperCol: { span: 14 }
        };
        return _react2.default.createElement(
            _modal_form2.default,
            { style: style, form: form, type: 'primary', onOk: this.onOk.bind(this, form), title: title, btnText: btnText },
            _react2.default.createElement(
                _form2.default,
                null,
                _react2.default.createElement(
                    FormItem,
                    _extends({}, formItemLayout, { required: true, label: '\u81EA\u63D0\u70B9\u540D\u79F0' }),
                    getFieldDecorator('name', {
                        rules: [{ required: true, message: '请输入自提点名称!' }],
                        initialValue: pickupStation.name
                    })(_react2.default.createElement(_input2.default, { type: 'text' }))
                ),
                _react2.default.createElement(
                    FormItem,
                    _extends({}, formItemLayout, { required: true, label: '\u8054\u7CFB\u4EBA' }),
                    getFieldDecorator('contact', {
                        rules: [{ required: true, message: '请输入联系人名称!' }],
                        initialValue: pickupStation.contact
                    })(_react2.default.createElement(_input2.default, { type: 'text' }))
                ),
                _react2.default.createElement(
                    FormItem,
                    _extends({}, formItemLayout, { required: true, label: '\u8054\u7CFB\u7535\u8BDD' }),
                    getFieldDecorator('mobile', {
                        rules: [{ required: true, message: '请输入自提点联系电话!' }],
                        initialValue: pickupStation.mobile
                    })(_react2.default.createElement(_input2.default, { type: 'text' }))
                ),
                _react2.default.createElement(
                    FormItem,
                    _extends({}, formItemLayout, {
                        label: '\u6240\u5728\u5730\u533A',
                        required: true
                    }),
                    getFieldDecorator('address', {
                        rules: [{ required: true, message: '请选择所在地区!' }],
                        initialValue: [pickupStation.address.province, pickupStation.address.city, pickupStation.address.district]
                    })(_react2.default.createElement(_cascader2.default, { options: _areas2.default }))
                ),
                _react2.default.createElement(
                    FormItem,
                    _extends({}, formItemLayout, {
                        label: '\u8BE6\u7EC6\u5730\u5740'
                    }),
                    getFieldDecorator('street', {
                        rules: [{ required: true, message: '请输入详细地址!' }],
                        initialValue: pickupStation.address.street
                    })(_react2.default.createElement(_input2.default, { placeholder: '\u8BF7\u8F93\u5165\u8BE6\u7EC6\u5730\u5740' }))
                )
            )
        );
    }
});

exports.default = _form2.default.create()(PickupStationForm);


//////////////////
// WEBPACK FOOTER
// ./src/js/components/pickup_station_form.js
// module id = 1550
// module chunks = 0